import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatWeDo from "@/pages/WhatWeDo";
import Technologies from "@/pages/Technologies";
import Platforms from "@/pages/Platforms";
import Growth from "@/pages/Growth";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import { LEGAL_PAGES } from "@/lib/legal";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/technologies" element={<Technologies />} />
          <Route path="/platforms" element={<Platforms />} />
          <Route path="/growth" element={<Growth />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          {LEGAL_PAGES.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<Legal page={p} />} />
          ))}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
